import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { useDispatch } from "react-redux";
import { Outlet, useParams } from "react-router-dom";
import { proEnabled } from "../constants";
import { heightWithToolbar } from "../global";
import { setFormOpen } from "../reducers/rhapsody";
import { ServicesList } from "../hooks/servicesList/servicesList";
import { usePro } from "../hooks/usePro/usePro";

export default function Services() {
  const param = useParams();
  const dispatch = useDispatch();
  const pro = usePro();
  if (param.emailID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: { xs: 2, md: 3 },
          pt: { xs: 2, md: 4 },
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1000,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Services</title>
        </Helmet>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "1.75rem",
                fontWeight: 700,
                letterSpacing: "-0.02em",
                lineHeight: 1.2,
              }}
            >
              Services
            </Typography>
          </Box>
          {proEnabled ? (
            <Button
              onClick={() =>
                dispatch(setFormOpen({ formID: "gig", isOpen: true }))
              }
              size="sm"
              color="info"
              sx={{ borderRadius: "999px", fontWeight: 600, px: 2 }}
              startDecorator={<i className="fa-solid fa-plus"></i>}
            >
              New Service
            </Button>
          ) : (
            []
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
            width: "100%",
          }}
        >
          <ServicesList tabs typeFilter />
        </Box>
      </Box>
    </>
  );
}
